<template>
  <div>
    <!-- KELK 愿景 -->
    <div class="wap1">
      <div class="wap1-content">
        <h1 class="title">{{ sustainableDevelopment.titleOne }}</h1>
        <p v-html="$convertPxToRem(sustainableDevelopment.contentOne)"></p>
      </div>
    </div>

    <!-- 公司战略 -->
    <div class="wap2">
      <div
        class="wap2-content"
        style="display: flex; justify-content: space-between"
      >
        <div class="box">
          <div class="image-container">
            <img src="../../assets/images/about/dev1.jpg" alt="" />
          </div>
          <div class="other-container">
            <h3 class="title">{{ sustainableDevelopment.list[0].title }}</h3>
            <p v-html="$convertPxToRem(sustainableDevelopment.list[0].content)"></p>
          </div>
        </div>
        <div class="box">
          <div class="image-container">
            <img src="../../assets/images/about/dev2.jpg" alt="" />
          </div>
          <div class="other-container">
            <h3 class="title">{{ sustainableDevelopment.list[1].title }}</h3>
            <p v-html="$convertPxToRem(sustainableDevelopment.list[1].content)"></p>
          </div>
        </div>
      </div>
      <div
        class="wap2-content"
        style="display: flex; justify-content: space-between; margin-top: 40px"
      >
        <div class="box">
          <div class="image-container">
            <img src="../../assets/images/about/dev3.jpg" alt="" />
          </div>
          <div class="other-container">
            <h3 class="title">{{ sustainableDevelopment.list[2].title }}</h3>
            <p v-html="$convertPxToRem(sustainableDevelopment.list[2].content)"></p>
          </div>
        </div>
        <div class="box">
          <div class="image-container">
            <img src="../../assets/images/about/dev4.jpg" alt="" />
          </div>
          <div class="other-container">
            <h3 class="title">{{ sustainableDevelopment.list[3].title }}</h3>
            <p v-html="$convertPxToRem(sustainableDevelopment.list[3].content)"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: 'Development',

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    sustainableDevelopment() {
      return this.currentLang.config.aboutPage.sustainableDevelopment
    }
  }
};
</script>

<style lang="scss" scoped>
.wap1 {
  padding-top: 70px;
  padding-bottom: 70px;
  .wap1-content {
    width: 1000px;
    margin: 0 auto 0;
    text-align: center;
    .title {
      font-size: 30px;
      color: #333;
      font-weight: 500;
    }
    p {
      font-size: var(--text-size-bit-larger);
      color: #777;
      line-height: 1.8;
      margin-top: 40px;
      text-align: justify;
      text-align-last: center;
    }
  }
}
.wap2 {
  padding-top: 80px;
  padding-bottom: 90px;
  background: #f5f5f5;

  .box {
    background-color: #fff;
  }

  .wap2-content {
    width: 1200px;
    margin: 0 auto 0;
    text-align: left;
    .image-container {
      width: 580px;
      height: 350px;
      overflow: hidden;
    }
    /* 鼠标经过图片放大动效 */
    .image-container :hover {
      transition: all 0.5s;
      transform: scale(1.1);
    }

    img {
      width: 100%;
    }

    .other-container {
      width: calc(580px - 60px);
      // height: calc(280px - 60px);
      margin: 30px;
      text-align: justify;

      .title {
        line-height: 44px;
        color: #fff;
        font-weight: 500;
        background: #e8363e;
        padding: 0 30px;
        display: inline-block;
      }
      p {
        font-size: var(--text-size-normal);
        line-height: 1.8;
        margin-top: 18px;
        color: #666;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/about/Development.vue